// src/components/FaviconUpdater.jsx
import { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import "../styles/Loader.css";
import { useLocation } from "react-router-dom";

const FaviconUpdater = () => {
  const [siteSettings, setSiteSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  /* =========================
     🔥 FETCH SITE SETTINGS
  ========================= */
  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/site-settings`);
        if (res.data) {
          setSiteSettings(res.data);
        }
      } catch (err) {
        console.error("Error fetching site settings:", err);
      } finally {
        // Small delay for smooth loader UX
        setTimeout(() => setLoading(false), 1200);
      }
    };

    fetchSiteSettings();
  }, []);

  /* =========================
     🔥 UPDATE FAVICON + SEO
  ========================= */
  useEffect(() => {
    if (!siteSettings) return;

    const { brandName, logo, logoContentType } = siteSettings;

    /* ========= FAVICON ========= */
    if (logo && logoContentType) {
      const faviconUrl = `data:${logoContentType};base64,${logo}`;

      let link =
        document.querySelector("link[rel~='icon']") ||
        document.createElement("link");

      link.rel = "icon";
      link.type = logoContentType;
      link.href = faviconUrl;
      document.head.appendChild(link);
    }

    /* ========= TITLE + META ========= */
    const finalBrandName = brandName || "Justivon";

    if (location.pathname === "/") {
      // 🏠 Home Page
      document.title = `${finalBrandName}`;

      let metaDesc = document.querySelector("meta[name='description']");
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.name = "description";
        document.head.appendChild(metaDesc);
      }

      metaDesc.content =
        "Justivon is a modern legal technology platform for connecting clients with verified advocates, managing cases, appointments, and secure legal services.";
    } else {
      // 📄 Other Pages
      document.title = finalBrandName;
    }
  }, [siteSettings, location.pathname]);

  /* =========================
     🔥 LOADER UI
  ========================= */
  if (loading) {
    return (
      <div className="favicon-loader">
        {siteSettings?.logo && siteSettings?.logoContentType && (
          <img
            src={`data:${siteSettings.logoContentType};base64,${siteSettings.logo}`}
            alt="Brand Logo"
            className="favicon-logo"
          />
        )}
        <div className="favicon-spinner"></div>
      </div>
    );
  }

  return null; // Nothing rendered after load
};

export default FaviconUpdater;
